module.exports = __webpack_public_path__ + "gd.svg?790e1345d1562abb6b44986a8c9ad4e0";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/gd.svg
// module id = 1253
// module chunks = 27